<template lang="pug">
  .download-poster
    .poster-box
      .poster(id="poster-image")
        img.bg(v-if="posterInfo.poster_background" :src="posterInfo.poster_background" @load="downloadImage" alt="海报背景图片")
        .info
          .shop-info
            .store-name.character-hiding-o {{posterInfo.store_name}}
            .store-address.character-hiding-o {{posterInfo.store_address}}
            .store-phone {{posterInfo.store_phone}}
          img.qr-code(:src="posterInfo.qr_code",alt="海报二维码")
</template>
<script>
import html2canvas from 'html2canvas'
export default {
  name: 'DownloadPoster',
  data () {
    return {
      // 海报信息
      posterInfo: {
        store_name: '', // 门店名称
        store_address: '', // 门店地址
        store_phone: '', // 门店电话
        qr_code: '', // 二维码
        poster_background: '', // 海报背景图片
      },
      filename: '海报', // 下载文件名称
    }
  },
  methods: {
    // 启动检查并初始化下载数据
    download (posterInfo, filename) {
      if (!posterInfo.poster_background) {
        this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '参数错误',
          content: '请检查数据',
        })
        return
      }
      this.posterInfo = posterInfo
      this.filename = filename
    },
    // 图片加载完成后自动调用，canvas -> base64
    downloadImage () {
      try {
        html2canvas(document.querySelector('#poster-image'), {
          useCORS: true,  // 允许跨域访问图片
          scale: 3,   // 绘制的像素密度，默认为1，建议设置为3，再大的话可能会出现图片绘制不完整的情况
        }).then(canvas => {
          canvas.className = 'canvas'
          let dataURL = canvas.toDataURL('image/jpeg')
          this.posterUrl = dataURL
          this.fileDownload(this.posterUrl)
        })
      } catch (error) {
        this.posterInfo = {}
        this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '海报下载失败',
          content: `${error}`,
        })
      }
    },
 // 下载图片(此处参数为base64地址)
    fileDownload (downloadUrl) {
      let aLink = document.createElement('a')
      aLink.style.display = 'none'
      aLink.href = downloadUrl
      aLink.download = `${this.filename}.jpg`
      // 触发点击-然后移除
      document.body.appendChild(aLink)
      aLink.click()
      document.body.removeChild(aLink)
      this.posterInfo = {}
    },
  },
}
</script>
<style lang="stylus" scoped>
.download-poster
  width 100%
  height 100%
  position absolute
  z-index -99
  .poster-box
    width 315px
    height auto
    padding 30px
    .poster
      width 315px
      height 100%
      display flex
      border-radius: 10px
      overflow hidden
      flex-direction column
      .bg
        width 100%
        height 429px
      .info
        width 100%
        height 110px
        background-color #ffffff
        padding 20px
        display flex
        justify-content space-between
        .qr-code
          width 72px
          height 72px
          background-color #eeeeee
          margin-right 10px
        .shop-info
          width 200px;
          display flex
          flex-direction: column
          font-size 12px
          color #ffffff
          // 由于html2canvas暂不支持text-overflow，暂采用此方案
          text-align: justify;
          overflow: hidden;
          .store-name
            font-size: 16px;
            font-weight: 500;
            color: #404040;
            margin-bottom 2px
            line-height 22px
          .store-address,.store-phone
            font-size 12px
            color: #6E6E72;
            text-indent 14px
            margin-top 6px
            line-height 17px
            position relative
          .store-address::after
            position absolute
            top 3px
            left 0
            content: ''
            width 9px
            height 12px
            background: url('~@/assets/icons/address-icon.png') no-repeat
            background-size contain
          .store-phone::after
            position absolute
            top 3px
            left 0
            content: ''
            width 9px
            height 12px
            background: url('~@/assets/icons/phone-icon.png') no-repeat
            background-size contain
</style>


// WEBPACK FOOTER //
// src/components/content/components/DownloadPoster.vue